/** Format a UNIX epoch (seconds) as a human-friendly date string. */
export function formatEpoch(epochSeconds: number | undefined | null): string {
  if (!epochSeconds) return "—";
  const d = new Date(epochSeconds * 1000);
  return d.toLocaleString();
}

/** Return a rough "in 34m" / "expired 2m ago" string for a UNIX epoch. */
export function relativeFromNow(epochSeconds: number | undefined | null): string {
  if (!epochSeconds) return "";
  const now = Math.floor(Date.now() / 1000);
  const diff = epochSeconds - now;
  const absMin = Math.abs(Math.round(diff / 60));
  if (absMin < 1) return diff >= 0 ? "in <1m" : "<1m ago";
  if (absMin < 60) return diff >= 0 ? `in ${absMin}m` : `${absMin}m ago`;
  const absH = Math.round(absMin / 60);
  return diff >= 0 ? `in ${absH}h` : `${absH}h ago`;
}
